import React, { useState, useEffect } from 'react';
import Rating from '@mui/material/Rating';
import css from './ListingAverageRating.module.css';
import { getListingRatingAvg } from '../../util/general';

import {
  getUserSubscriptionLevel,
  SUBSCRIPTION_LEVEL_2
} from '../../util/types';

const ListingAverageRating = props => {
  const { listingId, currentUser, isOwnListing, listing, className } = props;
  const userSubscriptionLevel = getUserSubscriptionLevel(currentUser);

  const listingPublicData = listing?.attributes?.publicData;
  const userPublicData = currentUser?.attributes?.profile?.publicData;

  const isClient = userPublicData?.userType === 'client';
  const isStartup = userPublicData?.providerType === 'startup';
  const isStartupListing = listingPublicData?.providerType === 'startup';

  if (userSubscriptionLevel < SUBSCRIPTION_LEVEL_2 && !isClient && !isOwnListing) return null;

  const votes = listingPublicData?.dedicatedVotes || [];
  const votesWithRating = votes.map(r => r.rating);
  const totalVotes = votes?.length;
  const votesSum = votesWithRating.reduce((a, b) => a + b, 0);
  const votesAvg = (votesSum / totalVotes).toFixed(1);

  const reviews = listingPublicData?.dedicatedReviews || [];
  const reviewsWithRating = reviews
    .filter(r => r.attributes.rating)
    .map(r => r.attributes.rating);

  const reviewsSum = reviewsWithRating.reduce((a, b) => a + b, 0);
  const reviewsAvg = (reviewsSum / reviewsWithRating.length).toFixed(1);
  const reviewsCount = reviews?.length;

  const reviewsCountLabel =
    '( ' + reviewsCount + (reviewsCount > 1 ? ' reviews' : ' review') + ') ';

  const votesCountLabel =
    '( ' + totalVotes + (totalVotes > 1 ? ' votes' : ' vote') + ') ';

  if(!reviewsCount && !totalVotes) return null

  return (
    <div className={`${css.wrapper} ${className}`}>
      {isStartupListing ? (
        <>
          {votesAvg ? (
            <div className={css.reviewsAvgWrapper}>
              <Rating
                name="read-only-rating"
                className={css.rating}
                value={votesAvg}
                precision={0.1}
                readOnly
              />
              <span className={css.label}>{votesCountLabel}</span>
            </div>
          ) : null}
        </>
      ) : (
        <>
          {reviewsAvg ? (
            <div className={css.reviewsAvgWrapper}>
              <Rating
                name="read-only-rating"
                className={css.rating}
                value={reviewsAvg}
                precision={0.1}
                readOnly
              />
              <span className={css.label}>{reviewsCountLabel}</span>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default ListingAverageRating;
